import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Default from './pages/Default';
import Renew from './pages/Renew';
import Republic from './pages/Republic';

const Routes = () => (
    <Router>
        <Switch>
            <Route exact path={'/'} component={Default} />
            <Route exact path={'/renew'} component={Renew} />
            <Route exact path={'/republic'} component={Republic} />
        </Switch>
    </Router>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/Routes.js